/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const RESTRICTED_PRODUCT_IDS = [9435528921305];
let hasRestrictedItem = false;

async function checkCartItems() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    hasRestrictedItem = cart.items.some((item) =>
      RESTRICTED_PRODUCT_IDS.includes(item.product_id),
    );

    return hasRestrictedItem;
  } catch (error) {
    console.error('Cart check error:', error);
    return false;
  }
}

function toggleDeliveryUI(val) {
  const $timeSelect = $('#time_select');
  const $boxes = $('div[id^="box"]');

  if (val === '地方発送' || val === '札幌市内配達' || val === '店舗受取') {
    $timeSelect.show();

    const targetBoxId = {
      '地方発送': '#box1',
      '札幌市内配達': '#box2',
      '店舗受取': '#box3',
    }[val];

    $boxes.hide();

    $(targetBoxId).show();
  } else {
    $timeSelect.hide();
    $boxes.hide();
  }

  if (hasRestrictedItem) {
    $timeSelect.hide();
  }
}

$(document).ready(function () {

  checkCartItems().then((restricted) => {
    const initialValue = $('#delivery__method').val();
    toggleDeliveryUI(initialValue);
  });
});

$(document).on('change', '#delivery__method', function () {
  $('#cartCheckoutButton').hide();
  $('.checkout_noselect').show();

  const selectedValue = $(this).val();
  toggleDeliveryUI(selectedValue);
});

$(document).on('change', '.delivery_time', function () {
  $('#cartCheckoutButton').show();
  $('.checkout_noselect').hide();
});
